import { mapState } from 'vuex'
import store from "../store"
import mixin_view from "@/common/mixin_view";



// 尝试将用户在根目录中的store/index.js的vuex的state变量，全部加载到全局变量中
let $uStoreKey = [];
try{
	$uStoreKey = store.state ? Object.keys(store.state) : [];
}catch(e){
	console.log(e);
}
const LOG = process.env.NODE_ENV == 'development' ? true : false;
// console.log(mapState($uStoreKey));

const mixin =  {
	created(){
		this.$_vueVuex = (name, value) => {
			this.$store.commit('$uStore', {
				name,value
			})
		};
		this.$_log = (val='')=>{
			if (LOG){
				console.log(val);
			}
		}
	},
	computed : {...mapState($uStoreKey)},
	mounted : async function(){
		try{
			let path = this.$route || false;
			if (path){
				// console.log(path);
				if (path.path != '/' && path.path != '/login_admin'){
					let user = this.$store.state.user || false;
					if (!user || Object.keys(user).length == 0){
						console.log(user);
						this.$router.replace('/');
						return;
					}else{
						this.$_vueVuex('is_login',true);
					}
				}
				if(path.path == '/one_page_detail' || path.path == '/ebook_detail'){
					this.$_vueVuex('is_show',false);
				}else{
					this.$_vueVuex('is_show',true);
				}
			}
		}catch (e){
			console.log(e);
			return false;
		}
	},
	methods : {
		...mixin_view,

	},
};

export default mixin;
